import qs from 'qs'
import Vue from 'vue'
import i18n from '@/i18n'
import store from 'Store'
import Nprogress from 'nprogress'
import VueRouter from 'vue-router'
import { loadCurretUser } from 'Services/helpers'

// Hide Spinner
Nprogress.configure({ showSpinner: false })

Vue.use(VueRouter)

// Routes modules
import client from './routes/client'
import employee from './routes/employee'
import notFound from './routes/notFound'

const routes = [
  // User Login
  {
    path: '/login',
    name: 'login',
    props: true,
    meta: { requireVisitor: true },
    component: () => import(/* webpackChunkName: "login" */ 'Pages/LoginPage'),

    children: [
      {
        path: 'reset/:pw_reset_userId?/:pw_reset_token?',
        name: 'password-reset',
        beforeEnter(to, from, next) {
          // If we dont recieve the user token and id we redirect to the login page
          if (!to.params.pw_reset_token || !to.params.pw_reset_userId) next({ name: 'login' })
          next()
        },
      },

      {
        path: 'forgot-password',
        name: 'forgot-password',
      },
    ],
  },

  {
    path: '/',
    name: 'dashboard',
    meta: { requireAuth: true },
    component: () => import(/* webpackChunkName: "dashboard" */ 'Pages/Dashboard'),
    redirect: () => {
      const user = loadCurretUser()
      // User dashboard redirection.
      if (user) {
        if (user.type === 'EMPLOYEE') {
          return { name: 'dashboard-team' }
        } else if (user.type === 'CLIENT') {
          // loading the client
          store.dispatch('client/load', user.account.id)
          return { name: 'dashboard-client', params: { account_id: user.account.id } }
        }
      } else {
        return { name: 'login' }
      }
    },
    // Child Routes
    children: [...employee, ...client, ...notFound],
  },

  {
    path: '/profile',
    name: 'user-profile',
    meta: { requireAuth: true },
    component: () => import(/* webpackChunkName: "user-profile" */ 'Pages/UserProfile'),
  },

  {
    path: '/network-error',
    name: 'network-error',
    meta: { requireError: true },
    beforeEnter(to, from, next) {
      if (to.meta.requireError && to.params.isError) next()
      else next({ name: '404' })
    },
    component: () => import(/* webpackChunkName: "network-error" */ 'Pages/NetworkErrorPage'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    if (!to.name?.includes('modal') && !from.name?.includes('modal')) return { x: 0, y: 0 }
  },

  // Avoiding the query to be inserted in the browser's navigation bar
  stringifyQuery(query) {
    const result = qs.stringify(query)
    return result ? '?' + result : ''
  },
})

// Globals Navegation guards
router.beforeEach((to, from, next) => {
  // baseURL
  const isBaseUrl = to.path === '/'
  // Loading user
  let currentUser = loadCurretUser()
  // setting up the user language ⤵
  if (currentUser) {
    if (i18n.locale !== currentUser.language) i18n.locale = currentUser.language
  }

  // Guards
  // ¿Is user logged in? ⤵
  if (to.matched.some((record) => record.meta.requireAuth) && !currentUser) {
    next({ name: 'login', query: to.path })
  }
  // If user is logged goes to the login page or base url  ⤵
  else if ((to.matched.some((record) => record.meta.requireVisitor) || isBaseUrl) && currentUser) {
    next({ name: 'dashboard', params: { user: currentUser } })
  }

  // ¿Does the user have authorization? ⤵
  else if (
    to.matched.some((record) => record.meta.requireEmployee) &&
    currentUser.type !== 'EMPLOYEE'
  ) {
    next({ name: '404' })
  }
  // ¿Is the user an editor? ⤵
  else if (to.matched.some((record) => record.meta.requireEditor) && !currentUser.is_editor) {
    next({ name: 'templates-listing' })
    const notifiaction = {
      icon: true,
      type: 'alert',
      message: 'No tienes permisos para acceder a esta página',
    }
    store.dispatch('notifications/add', notifiaction)
  }
  // Modal page ⤵
  else if (to.name?.includes('modal')) {
    store.dispatch('modal/open', to)
    next()
  }
  next()
})

export default router
